(() => {
  const element = document.getElementById('NPHoodieGiftConfig');
  if (!element || window.NPHoodieGift) return;
  const config = JSON.parse(element.textContent);
  const root = window.Shopify?.routes?.root || '/';
  const promoCodes = Object.values(config.codes);
  let queue = Promise.resolve();
  let checkoutBusy = false;

  async function request(path, body) {
    const response = await fetch(root + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : { cache: 'no-store' })
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || config.messages.error);
    return data;
  }

  function isGift(item) {
    return String(item.variant_id) === String(config.variantId) && item.properties?._nph_hoodie_gift === 'true';
  }

  function isProtection(item) {
    return String(item.variant_id) === String(config.protectionVariantId);
  }

  function hoodieCount(cart) {
    return cart.items.reduce((quantity, item) => quantity + (String(item.product_id) === String(config.productId) ? item.quantity : 0), 0);
  }

  function cartCodes(cart) {
    const codes = new Set((cart.discount_codes || []).map(item => item.code));
    for (const item of cart.items) {
      for (const allocation of item.line_level_discount_allocations || []) {
        const application = allocation.discount_application;
        if (application.type === 'discount_code') codes.add(application.title);
      }
    }
    for (const application of cart.cart_level_discount_applications || []) {
      if (application.type === 'discount_code') codes.add(application.title);
    }
    return Array.from(codes).filter(Boolean);
  }

  function expectedCodes(cart) {
    const count = hoodieCount(cart);
    const existing = cartCodes(cart).filter(code => !promoCodes.includes(code.toUpperCase()));
    if (count < 2) return existing;
    const codes = [...existing, config.codes.gift, count >= 3 ? config.codes.trio : config.codes.pair];
    if (count >= 3) codes.push(config.codes.protection);
    return codes;
  }

  function sameCodes(first, second) {
    return first.map(code => code.toUpperCase()).sort().join(',') === second.map(code => code.toUpperCase()).sort().join(',');
  }

  async function reconcile() {
    let cart = await request('cart.js');
    const count = hoodieCount(cart);
    const gifts = cart.items.filter(isGift);
    let changed = false;
    const updates = {};
    gifts.forEach((item, index) => {
      const quantity = count >= 2 && index === 0 ? 1 : 0;
      if (item.quantity !== quantity) updates[item.key] = quantity;
    });
    if (Object.keys(updates).length) {
      cart = await request('cart/update.js', { updates });
      changed = true;
    }
    if (count >= 2 && !cart.items.some(isGift)) {
      if (!config.available || !config.variantId) throw new Error(config.messages.unavailable);
      await request('cart/add.js', { items: [{ id: config.variantId, quantity: 1, properties: { _nph_hoodie_gift: 'true', 'Bundle bonus': config.messages.offer } }] });
      cart = await request('cart.js');
      changed = true;
    }
    if (count >= 3 && !cart.items.some(isProtection)) {
      if (!config.protectionAvailable || !config.protectionVariantId) throw new Error(config.messages.unavailable);
      await request('cart/add.js', { items: [{ id: config.protectionVariantId, quantity: 1, properties: { _nph_hoodie_protection: 'true', 'Bundle bonus': 'Free shipping protection with 3+ hoodies' } }] });
      cart = await request('cart.js');
      changed = true;
    }
    const codes = expectedCodes(cart);
    if (!sameCodes(cartCodes(cart), codes)) {
      cart = await request('cart/update.js', { discount: codes.join(',') });
      changed = true;
    }
    if (count >= 2) {
      const freeUnits = cart.items.filter(item => String(item.variant_id) === String(config.variantId)).reduce((total, item) => total + ((item.line_level_discount_allocations || []).some(allocation => allocation.discount_application.title.toUpperCase() === config.codes.gift) ? allocationQuantity(item) : 0), 0);
      if (!freeUnits) throw new Error(config.messages.discountError);
    }
    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(buttons => { buttons.hidden = count >= 2; });
    return { cart, changed, codes };
  }

  function allocationQuantity(item) {
    return (item.line_level_discount_allocations || []).reduce((total, allocation) => total + (allocation.discount_application.title.toUpperCase() === config.codes.gift ? allocation.amount : 0), 0) >= Number(item.original_price) ? 1 : 0;
  }

  function sync() {
    const next = queue.catch(() => {}).then(reconcile);
    queue = next;
    return next;
  }

  function showError(error) {
    let message = document.querySelector('[data-nph-cart-error]');
    if (!message) {
      message = document.createElement('p');
      message.dataset.nphCartError = 'true';
      message.className = 'nph-gift-cart-error';
      message.setAttribute('role', 'alert');
      const target = document.querySelector('#main-cart-footer .js-contents, .cart-drawer__footer, #MainContent');
      target?.prepend(message);
    }
    if (message) message.textContent = error.message || config.messages.error;
  }

  async function checkout(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutBusy) return;
    checkoutBusy = true;
    try {
      const result = await sync();
      const url = new URL(root + 'checkout', location.origin);
      if (result.codes.length) url.searchParams.set('discount', result.codes.join(','));
      window.location.assign(url.href);
    } catch (error) {
      checkoutBusy = false;
      showError(error);
    }
  }

  window.NPHoodieGift = { sync, hoodieCount, isGift, isProtection };
  document.addEventListener('click', event => {
    if (event.target.closest('[name="checkout"], a[href="/checkout"]')) checkout(event);
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout') checkout(event);
  }, true);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
      try {
        const result = await sync();
        if (result.changed) window.location.reload();
      } catch (error) { showError(error); }
    });
  }
  sync().then(result => {
    if (result.changed && document.querySelector('cart-items, cart-drawer-items') && window.location.pathname.replace(/\/$/, '').endsWith('/cart')) window.location.reload();
  }).catch(showError);
})();
